import type { GuidanceStep } from './guidance'

/**
 * A numbered list of settings to change, in the shape of the menus they are
 * in: an OS path stays left-to-right («System Settings › Notifications»),
 * a Persian one reads right-to-left, and the sentence around it is Persian
 * either way.
 */
export default function Steps({ steps }: { steps: GuidanceStep[] }) {
    return (
        <ol className="mt-2 flex flex-col gap-2 list-decimal pr-5">
            {steps.map((step, index) => (
                <li key={index} className="text-xs leading-6">
                    {step.path && (
                        <>
                            <bdi
                                dir={step.ltr ? 'ltr' : 'rtl'}
                                className="font-bold"
                            >
                                {step.path.join(step.ltr ? ' › ' : ' ← ')}
                            </bdi>
                            {': '}
                        </>
                    )}
                    {step.text}
                </li>
            ))}
        </ol>
    )
}
